import Alpine from "alpinejs";
import CallbackForm from './callback-form';

let callbackForm;
let returnFocus;
let previousOverflow;
const modalPanel = () => document.querySelector('[data-contact-modal-panel]');
const focusHeading = () => Alpine.nextTick(() => {
    const panel = modalPanel();
    const headings = panel && Array.from(panel.querySelectorAll('[data-modal-heading]'));
    const heading = headings && headings.find(element => element.getClientRects().length);
    if (heading) heading.focus();
});

/**
 * This sets up Alpine for handling contact form displaying across the site
 */
Alpine.store('contactUsModal', {
    show: false,
    showCallbackForm: false,
    callbackSent: false,

    /** Open the dialog and remember the control that opened it. */
    showModal() {
        if (!this.show) {
            returnFocus = document.activeElement;
            previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        this.show = true;
        focusHeading();
    },
    /** Close the dialog and give focus back to the original control. */
    hideModal() {
        if (!this.show) return;
        this.show = false;
        document.body.style.overflow = previousOverflow;
        if (callbackForm) callbackForm.close();
        if (returnFocus && returnFocus.isConnected) returnFocus.focus();
        this.showCallbackForm = false;
        this.resetCallbackForm();
    },
    /** Keep all open and close behaviour together. */
    toggle() {
        if (this.show) this.hideModal();
        else this.showModal();
    },
    /** Open the callback view and refresh its available dates. */
    showCallback() {
        this.showModal();
        this.showCallbackForm = true;
        this.scrollPanelToTop();
        focusHeading();
        const root = document.querySelector('[data-callback-endpoint]');
        if (root) {
            if (!callbackForm) callbackForm = new CallbackForm(root);
            callbackForm.open();
        }
    },
    /** Return to the contact choices without clearing an unfinished request. */
    hideCallback() {
        this.showCallbackForm = false;
        if (callbackForm) callbackForm.close();
        this.resetCallbackForm();
        this.scrollPanelToTop();
        Alpine.nextTick(() => modalPanel().querySelector('[data-x-bind="ContactUsCallbackShow"]').focus());
    },
    /** Start each view at its heading. */
    scrollPanelToTop() {
        const panel = document.querySelector('[data-contact-modal-panel]');
        if (panel) {
            panel.scrollTop = 0;
        }
    },
    /**
     * Put the callback form back so reopening the modal does not show a stale
     * confirmation. CF7 keeps the `sent` status on the form until it is reset.
     */
    resetCallbackForm() {
        if (! this.callbackSent) {
            return;
        }

        this.callbackSent = false;

        const form = document.querySelector('.request-callback-form .wpcf7-form');

        if (form && window.wpcf7 && typeof window.wpcf7.reset === 'function') {
            window.wpcf7.reset(form);
        }
    },
});

/**
 * The CF7 confirmation replaces the form (see form-contact-form-7.scss); scroll
 * the panel back up so the visitor actually lands on it.
 */
document.addEventListener('wpcf7mailsent', (event) => {
    if (! event.target.closest('.request-callback-form')) {
        return;
    }

    const store = Alpine.store('contactUsModal');

    store.callbackSent = true;
    if (callbackForm) callbackForm.close();
    store.scrollPanelToTop();
    Alpine.nextTick(() => {
        const response = event.target.querySelector('.wpcf7-response-output');
        if (response) {
            response.tabIndex = -1;
            response.focus();
        }
    });
});

// @todo: this could be refactored into one more concise binding to control `x-show`, `@click`, `@click.away`, etc.

Alpine.bind('ContactUsShow', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('contactUsModal').showModal();
    },
}));

Alpine.bind('ContactUsHide', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('contactUsModal').hideModal();
    },
}));

Alpine.bind('ContactUsCallbackShow', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('contactUsModal').showCallback();
    },
}));

Alpine.bind('ContactUsCallbackHide', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('contactUsModal').hideCallback();
    },
}));


// Trap keyboard focus in the visible dialog and restore it when the dialog closes.
document.addEventListener('keydown', event => {
    const store = Alpine.store('contactUsModal');
    if (!store.show) return;
    if (event.key === 'Escape') {
        event.preventDefault();
        store.hideModal();
    }
    if (event.key !== 'Tab') return;
    const panel = modalPanel();
    const focusable = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
        .filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) {
        event.preventDefault();
        panel.focus();
    } else if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
    }
});
